import './i18n.js';
import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './redux/store';
import * as Sentry from '@sentry/react';
import { MsalProvider } from '@azure/msal-react';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './AuthConfigure';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {}
);

const msalInstance = new PublicClientApplication(msalConfig as any);

async function startApp() {
  await msalInstance.initialize(); // REQUIRED before anything else

  // Set active account
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // MSAL events
  msalInstance.enableAccountStorageEvents();
  msalInstance.addEventCallback(event => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      //@ts-expect-error error
      event.payload?.account
    ) {
      //@ts-expect-error error
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  // ONLY NOW render the app
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Sentry.ErrorBoundary>
          <Provider store={store}>
            <AppProvider>
              <SettingsPanelProvider>
                <BreakpointsProvider>
                  <ToastContainer autoClose={3000} />
                  <RouterProvider router={router} />
                </BreakpointsProvider>
              </SettingsPanelProvider>
            </AppProvider>
          </Provider>
        </Sentry.ErrorBoundary>
      </MsalProvider>
    </React.StrictMode>
  );
}

startApp();
